import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/** Root path = go straight to the app. No marketing homepage. */
export default function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAFAFA] text-zinc-400">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }

  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}
